// class NWTCartUpsell {
//   constructor() {
//     // this.crossToggleState = {};
//     // this.pendingVids = new Set();
//     this.uxCrossObserver = null;
//     this.crossSwiper = null;

//     // this.init();
//   }

//   /* ---------------------------
//    INIT
//   ----------------------------*/
//   init() {
//     console.log('INIT  -----   !!!!!!!!!!');
    
//     this.handleCrossRule()  ;
//     this.initCrossToggleListener();
//     this.initCartListener();
//   }

//   /* ---------------------------
//    RULE LOADING
//   ----------------------------*/
//   searchCrossRule() {
//     const script = document.getElementById('upsell-config-data');

//     if (!script) {
//       return { status: "DO_NOT_FOUND" };
//     }

//     try {
//       const jsObj = JSON.parse(script.textContent);
//       return {
//         status: "FOUND_JSON",
//         data_handle: jsObj
//       };
//     } catch (error) {
//       return {
//         status: "INVALID_JSON",
//         message: error.message
//       };
//     }
//   }

//   handleCrossRule() {
//     const scriptTag = document.querySelector('script[data-custom-cross="true"]');
    
//     if (!scriptTag) return;
    
//     const defaultHandle = scriptTag.dataset.crossDefault;
//     const data = this.searchCrossRule();
//     console.log('NWT!!! - scriptTag', scriptTag, data);

//     const run = async (arr) => {
//       await this.initUxCross(arr);
//     };
//     if (data.status === 'FOUND_JSON') {
//       this.getCrossRuleArray(data.data_handle.upsells_coll).then(arr => {
//         this.setCrossLocal(arr);
//         run(arr);
//       });

//     } else {
//       const local = this.getCrossLocal();

//       if (local.length) {
//         run(local);
//       } else {
//         this.getDefaultArray(defaultHandle).then(arr => {
//           run(arr);
//         });
//       }
//     }
//   }

//   /* ---------------------------
//    DATA FETCH
//   ----------------------------*/
//   async getCrossRuleArray(rawArr) {
//     if (!rawArr) return [];

//     // const res = await fetch(`/collections/${handle}/products.json`);
//     // if (!res.ok) throw new Error("Collezione non trovata");

//     // const data = await res.json();

//     const newArr = rawArr
//     .map(p => {
//       const v = p.variants?.[0];

//       return {
//         title: p.title,
//         vid: String(v?.id || ''),
//         price: (v?.price / 100) || null,
//         comparePrice: (v?.compare_at_price / 100) || null,
//         image: p.images?.[0] || null
//       };
//     });

//     return newArr;

//     // return data.products.map(p => {
//     //   const v = p.variants?.[0];

//     //   return {
//     //     title: p.title,
//     //     vid: String(v?.id || ''),
//     //     price: v?.price || null,
//     //     comparePrice: v?.compare_at_price || null,
//     //     image: p.images?.[0]?.src || null
//     //   };
//     // });
//   }

//   async getDefaultArray(handle) {
//     if (!handle) return [];

//     const res = await fetch(`/collections/${handle}/products.json`);
//     if (!res.ok) throw new Error("Collezione non trovata");

//     const data = await res.json();


//     return data.products.map(p => {
//       const v = p.variants?.[0];

//       return {
//         title: p.title,
//         vid: String(v?.id || ''),
//         price: v?.price || null,
//         comparePrice: v?.compare_at_price || null,
//         image: p.images?.[0]?.src || null
//       };
//     });
//   }

//   /* ---------------------------
//    LOCAL STORAGE
//   ----------------------------*/
//   setCrossLocal(arr) {
//     if (arr) {
//       localStorage.setItem("crossSell_array", JSON.stringify(arr));
//     }
//   }

//   getCrossLocal() {
//     const arr = localStorage.getItem("crossSell_array");
//     if (!arr) return [];

//     try {
//       return JSON.parse(arr);
//     } catch (e) {
//       console.error("crossSell parse error", e);
//       return [];
//     }
//   }

//   /* ---------------------------
//    UI RENDER (SWIPER DRIVEN)
//   ----------------------------*/
//   // initUxCross(arr) {
//   //   if (!arr?.length) return;

//   //   const wrapper = document.querySelector('.cart-upsell-swiper .swiper-wrapper');
//   //   if (!wrapper) return;

//   //   wrapper.innerHTML = '';

//   //   const visibleProducts = arr.filter(
//   //     product => !this.findCrossInCart(String(product.vid))
//   //   );

//   //   visibleProducts.forEach((product, index) => {
//   //     const slide = this.createSwiperSlide(product, index);
//   //     wrapper.appendChild(slide);
//   //   });

//   //   if (!visibleProducts.length) {
//   //     if (this.crossSwiper) {
//   //       this.crossSwiper.destroy(true, true);
//   //       this.crossSwiper = null;
//   //     }

//   //     return;
//   //   }

//   //   this.rebuildSwiper();
//   // }

//   async initUxCross(arr) {
//     if (!arr?.length) return;

//     const cart = await fetch('/cart.js').then(r => r.json());

//     const cartVariants = new Set(
//       cart.items.map(item => String(item.variant_id))
//     );

//     const wrapper = document.querySelector(
//       '.cart-upsell-swiper .swiper-wrapper'
//     );

//     if (!wrapper) return;

//     wrapper.innerHTML = '';

//     const visibleProducts = arr.filter(
//       product => !cartVariants.has(String(product.vid))
//     );

//     visibleProducts.forEach(product => {
//       wrapper.appendChild(
//         this.createSwiperSlide(product)
//       );
//     });

//     if (!visibleProducts.length) {
//       if (this.crossSwiper) {
//         this.crossSwiper.destroy(true, true);
//         this.crossSwiper = null;
//       }

//       return;
//     }

//     this.rebuildSwiper();
//   }

//   createSwiperSlide(product, index) {
//     const slide = document.createElement('div');
//     slide.className = 'swiper-slide';

//     const price = product.price
//       ? `${parseFloat(product.price).toFixed(2).replace('.', ',')}€`
//       : '';

//     const comparePrice = product.comparePrice &&
//       parseFloat(product.comparePrice) > parseFloat(product.price)
//         ? `${parseFloat(product.comparePrice).toFixed(2).replace('.', ',')}€`
//         : '';

//     slide.innerHTML = `
//       <article class="upsell-card">

//         <div class="upsell-card__image">
//           ${
//             product.image
//               ? `<img src="${product.image}" alt="${product.title}" loading="lazy" width="80" height="80">`
//               : ''
//           }
//         </div>

//         <div class="upsell-card__info flex flex-col just-center">

//           <h3 class="upsell-card__title">
//             ${product.title}
//           </h3>

//           <div class="upsell-card__prices flex align-it-center">
//             ${
//               comparePrice
//                 ? `<span class="upsell-card__compare-price mono">${comparePrice}</span>`
//                 : ''
//             }
//             <span class="upsell-card__price mono">${price}</span>
//           </div>

//         </div>

//         <div class="upsell-card__actions flex align-it-center">

//           <button
//             type="button"
//             class="upsell-card__cta nwt-btn"
//             data-vid="${product.vid}"
//           >
//             AGGIUNGI
//           </button>

//         </div>

//       </article>
//     `;

//     return slide;
//   }

//   rebuildSwiper() {
//     if (this.crossSwiper) {
//       this.crossSwiper.destroy(true, true);
//     }

//     this.crossSwiper = new Swiper('.cart-upsell-swiper', {
//       slidesPerView: 1.15,
//       spaceBetween: 12,
//       autoHeight: true,
//       watchOverflow: true
//     });
//   }

//   // bindCrossUX(arr) {
//   //   arr.forEach(product => {
//   //     const vid = String(product.vid);

//   //     const btn = document.querySelector(
//   //       `.upsell-card__cta[data-vid="${vid}"]`
//   //     );

//   //     if (!btn) return;

//   //     const isInCart = this.crossToggleState[vid] !== undefined
//   //       ? this.crossToggleState[vid]
//   //       : this.findCrossInCart(vid);

//   //     btn.classList.toggle('is-added', isInCart);
//   //     btn.textContent = isInCart ? 'AGGIUNTO' : 'AGGIUNGI';
//   //   });
//   // }

//   /* ---------------------------
//    TOGGLE UX
//   ----------------------------*/
//   initCrossToggleListener() {
//     document.addEventListener('click', (event) => {
//       const btn = event.target.closest('.upsell-card__cta');
//       if (!btn) return;

//       const vid = btn.dataset.vid;
//       if (!vid) return;

//       btn.disabled = true;

//       this.addCrossProduct(vid).catch(() => {
//         btn.disabled = false;
//       });
//     });
//   }



//   /* ---------------------------
//    CART SYNC
//   ----------------------------*/
//   initCartListener() {
//     subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
//       const arr = this.getCrossLocal();

//       if (arr.length) {
//         await this.initUxCross(arr);
//       }
//     });
//   }

 

//   /* ---------------------------
//    CART ACTIONS
//   ----------------------------*/
//   async addCrossProduct(vid) {
//     const form = new FormData();
//     form.append('id', vid);
//     form.append('quantity', 1);
//     // console.log('ADDING VID', vid);

//     const config = fetchConfig('javascript');
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];
//     config.body = form;

//     const res = await fetch(routes.cart_add_url, config);
//     const data = await res.json();

//     if (!res.ok || data.status === 'error') {
//       throw new Error(data.description || 'add failed');
//     }

//     const cart = await fetch('/cart.js').then(r => r.json());

//     // console.log(
//     //   'CART AFTER ADD',
//     //   cart.items.map(item => item.variant_id)
//     // )

//     publish(PUB_SUB_EVENTS.cartUpdate, {});
//   }

//   async removeCrossProduct(vid) {
//     const items = document.querySelectorAll('.cart-item');

//     const item = [...items].find(i => {
//       const input = i.querySelector('input[data-quantity-variant-id]');
//       return input?.dataset.quantityVariantId === vid;
//     });

//     if (!item) throw new Error('item not found');

//     const index = item.querySelector('input[data-index]').dataset.index;

//     await this.updateQuantity(index, 0, null, vid);
//   }

//   // findCrossInCart(vid) {
//   //   const items = document.querySelectorAll('.cart-item');

//   //   return [...items].some(item => {
//   //     const input = item.querySelector('input[data-quantity-variant-id]');
//   //     return input?.dataset.quantityVariantId === vid;
//   //   });
//   // }
//   findCrossInCart(vid) {
//     const items = document.querySelectorAll('.cart-item');

//     // console.log(
//     //   'CHECK',
//     //   vid,
//     //   [...items].map(item =>
//     //     item.querySelector('input[data-quantity-variant-id]')
//     //       ?.dataset.quantityVariantId
//     //   )
//     // );

//     return [...items].some(item => {
//       const input = item.querySelector('input[data-quantity-variant-id]');
//       return input?.dataset.quantityVariantId === vid;
//     });
//   }
// }

// window.NWTCartUpsell = NWTCartUpsell;


class NWTCartUpsell {
  constructor() {
    this.pendingVids = new Set();
    this.uxCrossObserver = null;
    this.crossSwiper = null;
    this.buttonLabel = document.querySelector('script[data-button-label]')?.dataset.buttonLabel;
    this.chooseOptionsLabel = document.querySelector('script[data-button-label]')?.dataset.chooseOptionsLabel;
    this.loadingSpinnerSvg = document.querySelector('script[data-button-label]')?.dataset.loadingSpinnerSvg;
    // this.init();
  }

  /* ---------------------------
   INIT
  ----------------------------*/
  init() {
    // console.log('INIT  -----   !!!!!!!!!!');

    this.handleCrossRule();
    this.initCrossToggleListener();
    this.initCartListener();
  }

  /* ---------------------------
   RULE LOADING
  ----------------------------*/
  searchCrossRule() {
    const script = document.getElementById('upsell-config-data');

    if (!script) {
      return { status: "DO_NOT_FOUND" };
    }

    try {
      const jsObj = JSON.parse(script.textContent);
      return {
        status: "FOUND_JSON",
        data_handle: jsObj
      };
    } catch (error) {
      return {
        status: "INVALID_JSON",
        message: error.message
      };
    }
  }

  handleCrossRule() {
    const scriptTag = document.querySelector('script[data-custom-cross="true"]');

    if (!scriptTag) return;

    const defaultHandle = scriptTag.dataset.crossDefault;
    const data = this.searchCrossRule();
    // console.log('NWT!!! - scriptTag', scriptTag, data);

    const run = async (arr) => {
      await this.initUxCross(arr);
    };
    if (data.status === 'FOUND_JSON') {
      this.getCrossRuleArray(data.data_handle.upsells_coll).then(arr => {
        this.setCrossLocal(arr);
        run(arr);
      });

    } else {
      const local = this.getCrossLocal();

      if (local.length) {
        run(local);
      } else {
        this.getDefaultArray(defaultHandle).then(arr => {
          run(arr);
        });
      }
    }
  }

  /* ---------------------------
   DATA FETCH
  ----------------------------*/
  // async getCrossRuleArray(rawArr) {
  //   if (!rawArr) return [];

  //   const newArr = rawArr.map(entry => {
  //     const p = entry.product;
  //     const v = p?.variants?.[0];

  //     const basePrice = (v?.price / 100) || null;
  //     const discountPerc = parseFloat(entry.discountPerc) || 0;

  //     let price = basePrice;
  //     let comparePrice = (v?.compare_at_price / 100) || null;

  //     if (discountPerc > 0 && basePrice) {
  //       comparePrice = basePrice;
  //       price = basePrice - (basePrice * discountPerc / 100);
  //     }

  //     return {
  //       title: p?.title,
  //       vid: String(v?.id || ''),
  //       price,
  //       comparePrice,
  //       image: p?.images?.[0] || null
  //     };
  //   });

  //   return newArr;
  // }

  async getCrossRuleArray(rawArr) {
  if (!rawArr) return [];

  const newArr = rawArr.map(entry => {
    const p = entry.product;
    const variants = p?.variants || [];
    const v = variants[0];

    const discountPerc = parseFloat(entry.discountPerc) || 0;
    const basePrice = (v?.price / 100) || null;

    let price = basePrice;
    let comparePrice = (v?.compare_at_price / 100) || null;

    if (discountPerc > 0 && basePrice) {
      comparePrice = basePrice;
      price = basePrice - (basePrice * discountPerc / 100);
    }

    const qtyRule = v?.quantity_rule || {};
    const hasQtyRules =
      qtyRule.min > 1 ||
      qtyRule.max != null ||
      qtyRule.increment > 1;

    const needsQuickAdd = variants.length > 1 || hasQtyRules;

    return {
      id: p?.id,
      title: p?.title,
      url: `${window.location.origin}/products/${p?.handle}`,
      vid: String(v?.id || ''),
      price,
      comparePrice,
      image: p?.images?.[0] || null,
      needsQuickAdd
    };
  });

  return newArr;
}

  async getDefaultArray(handle) {
    if (!handle) return [];

    const res = await fetch(`/collections/${handle}/products.json`);
    if (!res.ok) throw new Error("Collezione non trovata");

    const data = await res.json();


    return data.products.map(p => {
      const v = p.variants?.[0];

      return {
        title: p.title,
        vid: String(v?.id || ''),
        price: v?.price || null,
        comparePrice: v?.compare_at_price || null,
        image: p.images?.[0]?.src || null
      };
    });
  }

  /* ---------------------------
   LOCAL STORAGE
  ----------------------------*/
  setCrossLocal(arr) {
    if (arr) {
      localStorage.setItem("crossSell_array", JSON.stringify(arr));
    }
  }

  getCrossLocal() {
    const arr = localStorage.getItem("crossSell_array");
    if (!arr) return [];

    try {
      return JSON.parse(arr);
    } catch (e) {
      console.error("crossSell parse error", e);
      return [];
    }
  }

  /* ---------------------------
   UI RENDER (SWIPER DRIVEN)
  ----------------------------*/
  async initUxCross(arr) {
    if (!arr?.length) return;

    this.ensureShopifySectionWrapper();
    const cart = await fetch('/cart.js').then(r => r.json());

    const cartVariants = new Set(
      cart.items.map(item => String(item.variant_id))
    );

    const wrapper = document.querySelector(
      '.cart-upsell-swiper .swiper-wrapper'
    );

    if (!wrapper) return;

    wrapper.innerHTML = '';

    
    const visibleProducts = arr.filter(
      product => !cartVariants.has(String(product.vid))
    );
  

    visibleProducts.forEach(product => {
      wrapper.appendChild(
        this.createSwiperSlide(product)
      );
    });

    if (!visibleProducts.length) {
      if (this.crossSwiper) {
        this.crossSwiper.destroy(true, true);
        this.crossSwiper = null;
      }

      return;
    }

    this.rebuildSwiper();
  }

  // createSwiperSlide(product, index) {
  //   const slide = document.createElement('div');
  //   slide.className = 'swiper-slide';

  //   const price = product.price
  //     ? `${parseFloat(product.price).toFixed(2).replace('.', ',')}€`
  //     : '';

  //   const comparePrice = product.comparePrice &&
  //     parseFloat(product.comparePrice) > parseFloat(product.price)
  //       ? `${parseFloat(product.comparePrice).toFixed(2).replace('.', ',')}€`
  //       : '';

  //   slide.innerHTML = `
  //     <article class="upsell-card">

  //       <div class="upsell-card__image">
  //         ${
  //           product.image
  //             ? `<img src="${product.image}" alt="${product.title}" loading="lazy" width="80" height="80">`
  //             : ''
  //         }
  //       </div>

  //       <div class="upsell-card__info flex flex-col just-center">

  //         <h3 class="upsell-card__title">
  //           ${product.title}
  //         </h3>

  //         <div class="upsell-card__prices flex align-it-center">
  //           ${
  //             comparePrice
  //               ? `<span class="upsell-card__compare-price mono">${comparePrice}</span>`
  //               : ''
  //           }
  //           <span class="upsell-card__price mono">${price}</span>
  //         </div>

  //       </div>

  //       <div class="upsell-card__actions flex align-it-center">

  //         <button
  //           type="button"
  //           class="upsell-card__cta nwt-btn"
  //           data-vid="${product.vid}"
  //         >
  //           ${this.buttonLabel}
  //         </button>

  //       </div>

  //     </article>
  //   `;

  //   return slide;
  // }


  ensureShopifySectionWrapper() {
  const swiperContainer = document.querySelector('.cart-upsell-swiper');
  if (!swiperContainer) return;

  const existingSection = swiperContainer.closest('.shopify-section');
  if (existingSection) return; // già presente, nulla da fare

  // Troviamo il primo antenato "ragionevole" (es. il drawer) e gli aggiungiamo
  // la classe + un id fittizio compatibile col replace() del tema
  const fallbackParent = swiperContainer.closest('cart-drawer, .drawer, body');
  if (fallbackParent && !fallbackParent.id) {
    fallbackParent.id = 'shopify-section-cart-upsell-fallback';
  }
  if (fallbackParent) {
    fallbackParent.classList.add('shopify-section');
  }
}

  createSwiperSlide(product) {
  const slide = document.createElement('div');
  slide.className = 'swiper-slide';

  const price = product.price
    ? `${parseFloat(product.price).toFixed(2).replace('.', ',')}€`
    : '';

  const comparePrice = product.comparePrice &&
    parseFloat(product.comparePrice) > parseFloat(product.price)
      ? `${parseFloat(product.comparePrice).toFixed(2).replace('.', ',')}€`
      : '';

  const spinnerMarkup = `
    <div class="loading__spinner hidden">
      ${this.loadingSpinnerSvg || ''}
    </div>
  `;

  const ctaMarkup = product.needsQuickAdd
    ? `
      <modal-opener data-modal="#QuickAdd-${product.id}">
        <button
          id="quick-add-${product.id}-submit"
          type="submit"
          name="add"
          class="quick-add__submit mono nwt-card-cta button button--full-width button--secondary"
          aria-haspopup="dialog"
          aria-labelledby="quick-add-${product.id}-submit upsell-title-${product.id}"
          data-product-url="${product.url}"
        >
          ${this.chooseOptionsLabel || 'Scegli opzioni'}
          ${spinnerMarkup}
        </button>
      </modal-opener>
      <quick-add-modal id="QuickAdd-${product.id}" class="quick-add-modal">
        <div
          role="dialog"
          aria-label="${product.title}"
          aria-modal="true"
          class="quick-add-modal__content global-settings-popup"
          tabindex="-1"
        >
          <button
            id="ModalClose-${product.id}"
            type="button"
            class="quick-add-modal__toggle"
            aria-label="Chiudi"
          ></button>
          <div id="QuickAddInfo-${product.id}" class="quick-add-modal__content-info"></div>
        </div>
      </quick-add-modal>
    `
    : `
      <button type="button" class="upsell-card__cta nwt-btn" data-vid="${product.vid}">
        ${this.buttonLabel}
      </button>
    `;

  slide.innerHTML = `
    <article class="upsell-card" data-product-card>
      <a href="${product.url || '#'}" class="upsell-card__image">
        ${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy" width="80" height="80">` : ''}
      </a>
      <div class="upsell-card__info flex flex-col just-center">
        <h3 class="upsell-card__title" id="upsell-title-${product.id}">${product.title}</h3>
        <div class="upsell-card__prices flex align-it-center">
          ${comparePrice ? `<span class="upsell-card__compare-price mono">${comparePrice}</span>` : ''}
          <span class="upsell-card__price mono">${price}</span>
        </div>
      </div>
      <div class="upsell-card__actions flex align-it-center">
        <div class="quick-add no-js-hidden">
          ${ctaMarkup}
        </div>
      </div>
    </article>
  `;

  return slide;
}

  rebuildSwiper() {
    if (this.crossSwiper) {
      this.crossSwiper.destroy(true, true);
    }

    this.crossSwiper = new Swiper('.cart-upsell-swiper', {
      slidesPerView: 1.15,
      spaceBetween: 12,
      autoHeight: true,
      watchOverflow: true
    });
  }

  /* ---------------------------
   TOGGLE UX
  ----------------------------*/
  initCrossToggleListener() {
    // GUARDIA ANTI-DUPLICAZIONE: se init() viene richiamato più volte
    // (es. perché lo script viene ri-eseguito ad ogni refresh del
    // cart-drawer/sezione carrello), senza questa guardia ogni chiamata
    // aggiungeva un ULTERIORE listener "click" sul document. Al click
    // successivo su "AGGIUNGI" tutti i listener accumulati scattavano
    // insieme, generando N richieste /cart/add.js in parallelo per la
    // stessa variante -> Shopify le somma -> quantità 2, 3, ecc.
    if (NWTCartUpsell._docClickBound) return;
    NWTCartUpsell._docClickBound = true;

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.upsell-card__cta');
      if (!btn) return;

      const vid = btn.dataset.vid;
      if (!vid) return;

      // Seconda linea di difesa: anche se per qualche motivo arrivassero
      // due click "in volo" per la stessa variante (doppio tap, ecc.),
      // ignoriamo il secondo finché il primo non è terminato.
      if (this.pendingVids.has(vid)) return;
      this.pendingVids.add(vid);

      btn.disabled = true;

      this.addCrossProduct(vid)
        .catch(() => {
          btn.disabled = false;
        })
        .finally(() => {
          this.pendingVids.delete(vid);
        });
    });
  }



  /* ---------------------------
   CART SYNC
  ----------------------------*/
  initCartListener() {
    // Stessa guardia anche qui: evita iscrizioni multiple allo stesso
    // evento cartUpdate se la classe viene istanziata/inizializzata
    // più volte nel corso della sessione.
    if (NWTCartUpsell._cartSubBound) return;
    NWTCartUpsell._cartSubBound = true;

    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      const arr = this.getCrossLocal();

      if (arr.length) {
        await this.initUxCross(arr);
      }
    });
  }



  /* ---------------------------
   CART ACTIONS
  ----------------------------*/
  async addCrossProduct(vid) {
    const form = new FormData();
    form.append('id', vid);
    form.append('quantity', 1);
    // console.log('ADDING VID', vid);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = form;

    const res = await fetch(routes.cart_add_url, config);
    const data = await res.json();

    if (!res.ok || data.status === 'error') {
      throw new Error(data.description || 'add failed');
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {});
  }

  async removeCrossProduct(vid) {
    const items = document.querySelectorAll('.cart-item');

    const item = [...items].find(i => {
      const input = i.querySelector('input[data-quantity-variant-id]');
      return input?.dataset.quantityVariantId === vid;
    });

    if (!item) throw new Error('item not found');

    const index = item.querySelector('input[data-index]').dataset.index;

    await this.updateQuantity(index, 0, null, vid);
  }

  findCrossInCart(vid) {
    const items = document.querySelectorAll('.cart-item');

    return [...items].some(item => {
      const input = item.querySelector('input[data-quantity-variant-id]');
      return input?.dataset.quantityVariantId === vid;
    });
  }
}

// Flag statici (vivono sulla classe, non sull'istanza): garantiscono che
// listener e subscription vengano collegati una sola volta per l'intera
// vita della pagina, indipendentemente da quante volte viene creato un
// nuovo "new NWTCartUpsell()" o richiamato .init().
NWTCartUpsell._docClickBound = false;
NWTCartUpsell._cartSubBound = false;

window.NWTCartUpsell = NWTCartUpsell;